"use strict";
/**
 * Returns a list with stopwords for the Spanish passive voice assessment.
 * @returns {Array} The list with stopwords.
 */

module.exports = function () {
    return ["pero", "ora", "aunque", "aun", "mientras", "porque", "apenas", "si", "antes", "después", "cómo", "como", "empero", "que", "cuanto", "cuando", "cual", "cuales", "quién", "quien", "quienes", "dónde", "adónde", "cuyo", "cuyos", "cuya", "cuyas"];
};
//# sourceMappingURL=stopwords.js.map
//# sourceMappingURL=stopwords.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/spanish/passiveVoice/stopwords.js
// module id = 443
// module chunks = 0